import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";

const twinkle = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: .35; transform: scale(.6); }
`;

/** Four-point sparkle centred on (cx, cy). */
const sparkle = (cx, cy, r) =>
  `M${cx} ${cy - r}Q${cx + r * 0.18} ${cy - r * 0.18} ${cx + r} ${cy}Q${cx + r * 0.18} ${cy + r * 0.18} ${cx} ${cy + r}Q${cx - r * 0.18} ${cy + r * 0.18} ${cx - r} ${cy}Q${cx - r * 0.18} ${cy - r * 0.18} ${cx} ${cy - r}Z`;

/**
 * The assistant's face: an 11 Plus Magic wand — navy wand with a bright tip, gold star, the
 * logo's pink/cyan swoosh and brand-coloured sparkles. SVG so it stays crisp from the 28px
 * message avatar to the 56px home greeting. thinking=true makes the sparkles twinkle.
 */
export default function AssistantLogo({ size = 40, thinking = false, title = "" }) {
  const sparkleSx = (delay) => ({
    transformBox: "fill-box",
    transformOrigin: "center",
    animation: thinking ? `${twinkle} 1.2s ${delay}s ease-in-out infinite` : "none",
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  });

  return (
    <Box
      component="svg"
      viewBox="7 2.5 56 56"
      width={size}
      height={size}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      sx={{ display: "block", flexShrink: 0, overflow: "visible" }}
    >
      {title && <title>{title}</title>}

      {/* swoosh trailing from the star, as in the site logo */}
      <path d="M41 22C33 16 24 15 15 19" fill="none" stroke="#2EC4F1" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M42.5 26.5C35 22 26.5 22 19 26" fill="none" stroke="#E8457C" strokeWidth="3.2" strokeLinecap="round" />

      {/* wand: navy body, white tip */}
      <path d="M11 55L36 30" stroke="#1F1A4D" strokeWidth="7.5" strokeLinecap="round" />
      <path d="M33.5 32.5L38.5 27.5" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M11 55L36 30" stroke="#3B2A9F" strokeWidth="2" strokeLinecap="round" opacity=".55" transform="translate(-1.2 -1.2)" />

      {/* star on the tip */}
      <path
        d="M46 6.5l3.5 7.2 7.9 1.2-5.7 5.6 1.3 7.9L46 24.7l-7 3.7 1.3-7.9-5.7-5.6 7.9-1.2z"
        fill="#FFC93C"
        stroke="#F5A700"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M43.6 12.6l1.6-3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" opacity=".9" />

      {/* sparkles */}
      <Box component="path" d={sparkle(57, 36, 4.2)} fill="#D62926" sx={sparkleSx(0)} />
      <Box component="path" d={sparkle(27, 9, 3.6)} fill="#3B2A9F" sx={sparkleSx(0.25)} />
      <Box component="path" d={sparkle(52, 50, 2.8)} fill="#F5A700" sx={sparkleSx(0.5)} />
    </Box>
  );
}
